import {
    faEye,
    faEyeSlash,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    CadastrarCanalAtendimentoController,
    DeletarCanalAtendimentoController,
    EditarCanalAtendimentoController,
    ListarCanalAtendimentoContoller,
} from "../../../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { CanalAtendimentoInterface } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/TipoCanalAtendimento/CanalAtendimentoInterfaces";
import SpinnerComponent from "../../../../../Loding/Spinner";

import Table from "../../../../../Table";
import "./styles.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TipoCanalAtendimentoFormData {
    canal: string;
    chave: string;
}

export default function TipoCanalAtendimento() {
    const { register, handleSubmit, formState, reset } = useForm();

    const [lstTipoCanalAtendimento, setLstTipoCanalAtendimento] = useState([
        {},
    ] as Array<CanalAtendimentoInterface>);

    useEffect(() => {
        updateListaTipoCanalAtendimento();
    }, []);

    function updateListaTipoCanalAtendimento() {
        ListarCanalAtendimentoContoller(true).then((response) => {
            setLstTipoCanalAtendimento(response);
        });
    }

    //Tabela
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_TIPO_CANAL_ATENDIMENTO",
            text: "Tipos de Canal de Atendimento",
            formatter: rowCanalAtendimento,
            sort: true,
        },
    ];
    function rowCanalAtendimento(cell: string, row: CanalAtendimentoInterface) {
        return (
            <div className="rowCapysTCA d-flex justify-content-between align-items-center">
                <div>
                    <label className="mb-1">
                        {row.DS_TIPO_CANAL_ATENDIMENTO}
                    </label>
                    <div>
                        {row.ID_CHAVE_ERP && (
                            <span
                                className={`label abel-pill label-inline label-primary`}
                            >
                                {row.ID_CHAVE_ERP}
                            </span>
                        )}
                    </div>
                </div>
                <div>
                    {row.FL_ATIVO ? (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="desativar-tooltip">
                                    Desativar Canal Atendimento
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn  btn-sm btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    EditarCanalAtendimentoController({
                                        ...row,
                                        FL_ATIVO: false,
                                    }).then(() => {
                                        updateListaTipoCanalAtendimento();
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEyeSlash} size="lg" />
                            </button>
                        </OverlayTrigger>
                    ) : (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ativar-tooltip">
                                    Ativar Canal Atendimento
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn  btn-sm btn-outline-primary font-weight-bold mr-2"
                                onClick={() => {
                                    EditarCanalAtendimentoController({
                                        ...row,
                                        FL_ATIVO: true,
                                    }).then(() => {
                                        updateListaTipoCanalAtendimento();
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEye} size="lg" />
                            </button>
                        </OverlayTrigger>
                    )}
                    <button
                        className="btn  btn-sm btn-outline-danger font-weight-bold"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este canal de atendimento?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarCanalAtendimentoController(
                                        row.ID_TIPO_CANAL_ATENDIMENTO
                                    ).then(() => {
                                        updateListaTipoCanalAtendimento();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                    </button>
                </div>
            </div>
        );
    }

    const handleTipoCanalAtendimentoFormSubmit = (
        formData: TipoCanalAtendimentoFormData
    ) => {
        CadastrarCanalAtendimentoController({
            DS_TIPO_CANAL_ATENDIMENTO: formData.canal,
            ID_CHAVE_ERP: formData.chave,
        }).then(() => {
            updateListaTipoCanalAtendimento();
            reset();
        });
    };

    return lstTipoCanalAtendimento.length ? (
        <>
            <div className="Row1 d-flex flex-columns row">
                <div className="col-12 collapse mb-5" id="collapseForm">
                    <h5 className="text-center">
                        Cadastre Tipo de Canal de Atendimento
                    </h5>
                    <form
                        onSubmit={handleSubmit(
                            handleTipoCanalAtendimentoFormSubmit
                        )}
                        className="w-100 align-itens-center"
                    >
                        <div className="row mb-3">
                            <div className="col-12 col-lg-9">
                                <label htmlFor="canal">
                                    Canal de Atendimento
                                </label>
                                <input
                                    type="text"
                                    name="canal"
                                    className={`form-control placeholder-dark-50 ${
                                        formState.errors.canal && "is-invalid"
                                    }`}
                                    ref={register({
                                        required:
                                            "Insira o canal de atendimento",
                                    })}
                                />
                            </div>
                            <div className="col-12 col-lg-3">
                                <label htmlFor="chave">Chave ERP</label>
                                <input
                                    type="text"
                                    name="chave"
                                    className={`form-control placeholder-dark-50`}
                                    ref={register}
                                />
                            </div>
                            <div className="col-12 d-flex align-items-end mt-3">
                                <button className="btn btn-outline-success font-weight-bold justify-content-center d-flex w-100 ">
                                    <FontAwesomeIcon
                                        icon={faPlus}
                                        size="lg"
                                        className="mr-1"
                                    />{" "}
                                    Cadastrar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="col-12 mt-5">
                    <Table
                        keyField="ID_TIPO_CANAL_ATENDIMENTO"
                        columns={columns}
                        data={lstTipoCanalAtendimento}
                        sizePerPage={5}
                    />
                </div>
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
